// cache-bust v9 - engagement tracking
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initEngagementTracking } from "@/lib/obc-tracker-engagement";

console.log('[OBC] build:', '2026-05-07T16:30');

// The static <head> (index.html / prerender) ships a canonical for non-JS
// crawlers. Once React mounts, Helmet owns the canonical — drop the static
// one so every page exposes exactly one canonical link.
document.head
  .querySelectorAll('link[rel="canonical"]:not([data-rh])')
  .forEach((el) => el.remove());

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Wait one tick so the main OBC tracker writes visitor_id/session_id first
if (typeof window !== "undefined") {
  setTimeout(() => initEngagementTracking(), 500);
}
